<template>
  <div id="body-id" class="width-100 min-height flex-column align-items-center justify-content-start" style="background: #f6f6f6">
    <van-image width="100%" height="12rem" :src="itemDetail.goods_picture_url" fit="contain" />
    <div
      class="flex-column align-items-center justify-content-around width-100 bg-blue"
      :style="{ height: (bodyIdWidth / 750) * 115 + 'px', padding: '2% 3%' }"
    >
      <div class="flex-row align-items-center justify-content-spaceBetween width-100">
        <div
          class="bg-white br-big fm-sh-normal"
          style="font-size: 12px; transform: scale(0.8); color: #0053f0; padding: 2px 8px; line-height: 12px; margin-left: -5px"
        >
          本期奖品
        </div>
        <div class="white fm-sh-medium" v-if="!hide" style="font-size: 12px; transform: scale(0.8); margin-right: -5px">距离结束还剩:</div>
      </div>
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween">
        <div class="white fm-sh-regular fs-mid-sml">
          {{ itemDetail.goods_name }}
        </div>
        <!-- <van-count-down :time="itemDetail.endTime">
          <template #default="timeData">
            <div class="flex-row align-items-end">
              <span style="display: inline-block" class="white fs-sml fm-sh-medium margin-rs"> {{ timeData.days }}天 </span>
              <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card fm-sh-light">
                {{ timeData.hours }}
              </span>
              <span class="colon white">:</span>
              <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card fm-sh-light">
                {{ timeData.minutes }}
              </span>
              <span class="colon white">:</span>
              <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card fm-sh-light">
                {{ timeData.seconds }}
              </span>
            </div>
          </template>
        </van-count-down> -->
        <div class="flex-row align-items-end justify-content-around" v-if="!hide">
          <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card">{{ dayTime }}</span
          >: <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card">{{ hourTime }}</span
          >: <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card">{{ minuteTime }}</span
          >:
          <span style="display: inline-block; transform: scale(0.8); margin-top: 3px" class="blue time-card">{{ secondTime }}</span>
        </div>
      </div>
    </div>
    <div class="bg-white width-100 margin-bss flex-column align-items-star justify-content-center" style="padding: 2% 5%">
      <div style="color: #666" class="fs-mid-sml fm-sh-regular">奖品数量：{{ itemDetail.goods_num }}份</div>
      <div style="color: #666" class="fs-mid-sml fm-sh-regular" v-if="itemDetail.end_time">活动结束时间：{{ itemDetail.end_time }}</div>
      <div style="color: #666" class="fs-mid-sml fm-sh-regular">参与次数：{{ itemDetail.involved_num }}</div>
    </div>
    <div
      class="width-100 textAlign-c fw-mid fs-big margin-bss"
      v-if="showZJ"
      style="background: #e1efff; color: #0053f0; height: 2.5rem; line-height: 2.5rem"
    >
      已开奖，请前往中奖记录查看。
    </div>
    <div class="bg-white width-100 flex-row align-items-center justify-content-around" style="padding: 3% 5% 0">
      <div class="width-100 flex-row align-items-center justify-content-around" style="border-bottom: 1px solid #eee; padding-bottom: 10px">
        <div
          :class="['fs-mid-sml', active == 0 ? 'fm-sh-bold' : 'fm-sh-regular']"
          :style="{ color: active == 0 ? '#0053f0' : '#666' }"
          @click="active = 0"
        >
          产品介绍
        </div>
        <div
          :class="['fs-mid-sml', active == 1 ? 'fm-sh-bold' : 'fm-sh-regular']"
          :style="{ color: active == 1 ? '#0053f0' : '#666' }"
          @click="active = 1"
        >
          我的奖券
        </div>
        <!-- <div
          :class="['fs-mid-sml', active == 2 ? 'fm-sh-bold' : 'fm-sh-regular']"
          :style="{ color: active == 2 ? '#0053f0' : '#666' }"
          @click="active = 2"
        >
          兑奖流程
        </div> -->
      </div>
    </div>
    <div v-if="active == 0" v-html="itemDetail.details" class="width-100"></div>
    <div v-if="active == 1" class="flex-column width-100 bg-white align-items-center" style="padding: 0 5% 3%">
      <div
        v-show="list.length != 0"
        class="flex-row align-items-center justify-content-spaceBetween width-100"
        style="height: 3.5rem; border-bottom: 1px solid #eee"
        v-for="(item, key) in list"
        :key="key"
      >
        <div class="fm-sh-regular fs-mid-sml">{{ item.lottery_ticket }}</div>
        <div class="fs-sml fm-sh-regular grey-999">{{ item.cre_time }}</div>
      </div>
      <div v-if="list.length == 0" style="height: 10rem; line-height: 10rem" class="textAlign-c fs-mid-big grey-999">暂无奖券</div>
    </div>
    <div v-if="active == 2" class="width-100 margin-ts" style="padding: 0 5%">
      <div style="padding: 3%" class="br-reg width-100 bg-white flex-column align-items-center justify-content-start">
        <div style="border-bottom: 1px solid #eee; padding-bottom: 3%; margin-bottom: 3%" class="width-100 flex-row align-items-center">
          <van-image :src="itemDetail.shop_logo" width="2.5rem" height="2.5rem" fit="fill" />
          <div class="fs-mid-sml fm-sh-regular margin-l">{{ itemDetail.shop_name }}</div>
        </div>
        <div class="width-100 flex-column align-items-star justify-content-center">
          <div class="fs-sml fm-sh-regular margin-bss" style="color: #666">
            <van-icon name="location-o" size="12" color="#666666" class="margin-rs" />{{ itemDetail.shop_address }}
          </div>
          <div class="fs-sml fm-sh-regular" style="color: #666">
            <van-icon name="phone-o" size="12" color="#666666" class="margin-rs" />{{ itemDetail.shop_phone }}
          </div>
        </div>
      </div>
      <div style="padding: 3%" class="br-reg width-100 bg-white flex-column align-items-center justify-content-start margin-ts">
        <div class="fs-mid-sml fm-sh-bold width-100 textAlign-l">温馨提示</div>
        <!-- <div class="flex-row align-items-center justify-content-spaceBetween width-100 margin-ts">
          <div class="fs-mid-sml fm-sh-regular" style="color: #666">有效时间：</div>
          <div class="fs-mid-sml fm-sh-regular" style="color: #666">{{ itemDetail }}</div>
        </div> -->
        <div class="flex-row align-items-center justify-content-spaceBetween width-100 margin-ts">
          <div class="fs-mid-sml fm-sh-regular" style="color: #666">营业时间：</div>
          <div class="fs-mid-sml fm-sh-regular" style="color: #666">{{ itemDetail.shop_business_hours }}</div>
        </div>
        <div class="flex-row align-items-center justify-content-spaceBetween width-100 margin-ts">
          <div class="fs-mid-sml fm-sh-regular" style="color: #666">使用规则：</div>
          <div class="fs-mid-sml fm-sh-regular" style="color: #666">{{ itemDetail.shop_rules }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let interval = null;
import { getActivityRecordInfo, getActivityMemberTicketLists } from '@/api/manuscriptIndex';
import { Toast } from 'vant';
export default {
  data() {
    return {
      showZJ: false,
      dayTime: 0,
      hourTime: 0,
      minuteTime: 0,
      secondTime: 0,
      active: 0,
      bodyIdWidth: 0,
      list: [],
      itemDetail: {},
      hide: false
    };
  },
  watch: {
    '$route.path': {
      deep: true,
      handler(v, o) {
        if (o == '/luckyDrawDetails') {
          console.log(o);
          this.$destroy();
        }
      }
    }
  },
  beforeMount() {
    this.getActivityMemberTicketLists();
    getActivityRecordInfo({ id: this.$route.query.id })
      .then((res) => {
        if (res.code == 0) {
          this.itemDetail = res.data;
          clearInterval(interval);
          interval = setInterval(() => {
            let times = this.daysDistance(res.data.end_time.replace(/-/g, '/'), new Date());
            if (times < 0) {
              this.hide = true;
              clearInterval(interval);
            } else {
              let day = Math.floor(times / 1000 / 3600 / 24);
              let hour = Math.floor(times / 1000 / 3600);
              let minutes = Math.floor(times / 1000 / 60);
              this.dayTime = Math.floor(times / 1000 / 3600 / 24);
              this.hourTime = Math.floor(times / 1000 / 3600) - day * 24;
              this.minuteTime = Math.floor(times / 1000 / 60) - hour * 60;
              this.secondTime = Math.floor(times / 1000) - minutes * 60;
            }
          }, 1000);
        } else {
          Toast.fail('获取奖品信息失败');
          this.$router.back();
        }
      })
      .catch((err) => {
        console.log(err);
      });
    this.$nextTick(() => {
      this.bodyIdWidth = document.getElementById('body-id').clientWidth;
    });
  },
  beforeRouteLeave(to, from, next) {
    clearInterval(interval);
    next();
  },
  methods: {
    getActivityMemberTicketLists() {
      getActivityMemberTicketLists({ id: this.$route.query.id })
        .then((res) => {
          if (res.code == 0) {
            this.list = res.data;
            this.list.forEach((item) => {
              if (item.state == 1) {
                this.showZJ = true;
              }
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //date1和date2是2019-06-18格式
    daysDistance(date1, date2) {
      //parse() 是 Date 的一个静态方法 , 所以应该使用 Date.parse() 来调用，而不是作为 Date 的实例方法。返回该日期距离 1970/1/1 午夜时间的毫秒数
      date1 = Date.parse(date1);
      date2 = Date.parse(date2);
      //计算两个日期之间相差的毫秒数的绝对值
      var ms = date1 - date2;
      //毫秒数除以一天的毫秒数,就得到了天数
      return ms;
    }
  }
};
</script>

<style scoped>
.time-card {
  border-radius: 0.25rem;
  background: #fff;
  width: 1.3rem;
  height: 1.3rem;
  text-align: center;
  line-height: 1.3rem;
  font-size: 12px;
}
::v-deep .van-tabs__line {
  display: none;
}
::v-deep .van-tabs__wrap {
  border-bottom: 1px solid #efeff4;
}
</style>
